var map = {
	"./beaker2/beaker2_active.png": 2113,
	"./beaker2/beaker2_disabled.png": 2114,
	"./beaker2/beaker2_success.png": 2115,
	"./bg-pattern.png": 875,
	"./body_substance1/body_substance1_active.png": 2116,
	"./body_substance1/body_substance1_disabled.png": 2117,
	"./body_substance1/body_substance1_success.png": 2118,
	"./cat-final-test-bg.png": 2119,
	"./cat-map-bg.png": 2120,
	"./catMapNextBtn/catMapNextBtn_active.png": 2121,
	"./clock.png": 2122,
	"./closeIcon.png": 269,
	"./completeIcon.png": 103,
	"./exam1/exam1.png": 2123,
	"./exam2/exam2.png": 2124,
	"./exam3/exam3.png": 2125,
	"./exam4/exam4.png": 2126,
	"./exam6/exam6.png": 2127,
	"./exam7/exam7.png": 2128,
	"./exam8/exam8.png": 2129,
	"./farm-map-bg (with last icon).png": 2130,
	"./farm-map-bg.png": 418,
	"./farm-map2-bg.png": 2131,
	"./farm4map/1.png": 876,
	"./farm4map/10.png": 877,
	"./farm4map/11.png": 878,
	"./farm4map/12.png": 879,
	"./farm4map/13.png": 880,
	"./farm4map/14.png": 881,
	"./farm4map/15.png": 882,
	"./farm4map/2.png": 883,
	"./farm4map/3.png": 884,
	"./farm4map/4.png": 885,
	"./farm4map/5.png": 886,
	"./farm4map/6.png": 887,
	"./farm4map/7.png": 888,
	"./farm4map/8.png": 889,
	"./farm4map/9.png": 890,
	"./farm5map/farm_5_video1.png": 891,
	"./farm5map/farm_5_video2.png": 892,
	"./farm5map/logic_wedge1.png": 893,
	"./farm5map/logic_wedge2.png": 894,
	"./farm5map/logic_wedge3.png": 895,
	"./farm5map/logic_wedge4.png": 896,
	"./farm5map/logic_wedge5.png": 897,
	"./farm5map/logic_wedge6.png": 898,
	"./farm5map/mechanisms_maker1.png": 899,
	"./farm5map/nail_and_screw1.png": 900,
	"./farm5map/сut_some_wood1.png": 901,
	"./farm_1_map/presentation.png": 902,
	"./farm_1_map/video.png": 903,
	"./farm_4_auth_bg.png": 904,
	"./farm_5_auth_bg.png": 905,
	"./farm_5_bg.png": 906,
	"./finalMapVideo1/finalMapVideo1_active.png": 2132,
	"./finalMapVideo1/finalMapVideo1_disabled.png": 2133,
	"./finalMapVideo1/finalMapVideo1_success.png": 2134,
	"./final_test1/final_test1_active.png": 2135,
	"./final_test1/final_test1_disabled.png": 2136,
	"./final_test1/final_test1_success.png": 2137,
	"./find_in_the_picture1/find_in_the_picture1_active.png": 2138,
	"./greece-blocks-mp-bg.png": 270,
	"./greeceBook.png": 271,
	"./hypothesis1/hypothesis1_active.png": 2139,
	"./hypothesis1/hypothesis1_disabled.png": 2140,
	"./hypothesis1/hypothesis1_success.png": 2141,
	"./hypothesis2/hypothesis2_active.png": 2142,
	"./hypothesis2/hypothesis2_disabled.png": 2143,
	"./hypothesis2/hypothesis2_success.png": 2144,
	"./initialMapVideo1/initialMapVideo1_active.png": 2145,
	"./initialMapVideo1/initialMapVideo1_disabled.png": 2146,
	"./initialMapVideo1/initialMapVideo1_success.png": 2147,
	"./lab_volume1/lab_volume1_active.png": 2148,
	"./lab_volume1/lab_volume1_disabled.png": 2149,
	"./lab_volume1/lab_volume1_success.png": 2150,
	"./laboratory10/laboratory10_active.png": 2151,
	"./laboratory10/laboratory10_disabled.png": 2152,
	"./laboratory10/laboratory10_success.png": 2153,
	"./measure1/measure1_active.png": 2154,
	"./measure1/measure1_disabled.png": 2155,
	"./measure1/measure1_success.png": 2156,
	"./measure2/measure2_active.png": 2157,
	"./measure2/measure2_disabled.png": 2158,
	"./measure2/measure2_success.png": 2159,
	"./measure3/measure3_active.png": 2160,
	"./measure3/measure3_disabled.png": 2161,
	"./measure3/measure3_success.png": 2162,
	"./measure4/measure4_active.png": 2163,
	"./measure4/measure4_disabled.png": 2164,
	"./measure4/measure4_success.png": 2165,
	"./measurement_duplicate1/measurement_duplicate1_active.png": 2166,
	"./measurement_duplicate1/measurement_duplicate1_disabled.png": 2167,
	"./measurement_duplicate1/measurement_duplicate1_success.png": 2168,
	"./notCompleteIcon.png": 907,
	"./phenomena1/phenomena1_active.png": 2169,
	"./phenomena1/phenomena1_disabled.png": 2170,
	"./phenomena1/phenomena1_success.png": 2171,
	"./phenomena2/phenomena2_active.png": 2172,
	"./phenomena2/phenomena2_disabled.png": 2173,
	"./phenomena2/phenomena2_success.png": 2174,
	"./phenomena3/phenomena3_active.png": 2175,
	"./phenomena3/phenomena3_disabled.png": 2176,
	"./phenomena3/phenomena3_success.png": 2177,
	"./school_task_auth_bg.png": 908,
	"./successArrow.png": 909,
	"./test1/test1_active.png": 2178,
	"./test1/test1_disabled.png": 2179,
	"./test1/test1_success.png": 2180,
	"./units1/units1_active.png": 2181,
	"./units1/units1_disabled.png": 2182,
	"./units1/units1_success.png": 2183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1041;